// TODO(RBAC, parent #641 #647): admin only
import { create } from '@bufbuild/protobuf'
import type { Timestamp } from '@bufbuild/protobuf/wkt'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import type {
  WorkflowCaseTag,
  WorkflowSection,
} from '@ebalance/proto/bffuser/v1/workflow_template_model_pb'
import { listWorkflowTemplates } from '@ebalance/proto/bffuser/v1/workflow_template_service-WorkflowTemplateService_connectquery'
import {
  ListWorkflowTemplatesRequestSchema,
  type ListWorkflowTemplatesResponse,
} from '@ebalance/proto/bffuser/v1/workflow_template_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * ワークフロー雛形一覧行型。
 *
 * #1: schedule フィールドは廃止済み (proto 生成物では optional になったが、
 * frontend 一覧表示からは削除し使用しない)。
 */
export type WorkflowTemplateRow = {
  id: string
  name: string
  description: string | undefined
  section: WorkflowSection
  isBuiltIn: boolean
  bigStepCount: number
  subStepTotalCount: number
  /** AC-WFT-001: 雛形の表示順 (backend が display_order 昇順で返す)。 */
  displayOrder: number | undefined
  /** AC-10/AC-006: 雛形のデフォルトタグ (新規ケース作成時のプリフィル元)。 */
  defaultTags: WorkflowCaseTag[]
  // optimistic lock 用に proto Timestamp で保持する。表示時のみ timestampDate で Date 変換。
  updatedAt: Timestamp | undefined
}

function convertItem(
  item: ListWorkflowTemplatesResponse['templates'][number],
): WorkflowTemplateRow {
  return {
    id: item.id,
    name: item.name,
    description: item.description,
    section: item.section,
    isBuiltIn: item.isBuiltIn,
    bigStepCount: item.bigSteps.length,
    subStepTotalCount: item.bigSteps.reduce(
      (sum, b) => sum + b.subSteps.length,
      0,
    ),
    displayOrder: item.displayOrder,
    defaultTags: item.defaultTags,
    updatedAt: item.updatedAt,
  }
}

export function convertListWorkflowTemplatesResponse(
  resp: ListWorkflowTemplatesResponse,
): WorkflowTemplateRow[] {
  return resp.templates.map(convertItem)
}

type Options = {
  /**
   * false の間は取得しない (= 常時マウントされるダイアログ内で `open` になるまで
   * 発火を遅延する用途)。省略時は従来どおり有効。
   */
  enabled?: boolean
}

export function useListWorkflowTemplates(
  options?: Options,
): UseQueryResult<ListWorkflowTemplatesResponse, ConnectError> {
  return useQuery(
    listWorkflowTemplates,
    create(ListWorkflowTemplatesRequestSchema, {}),
    { enabled: options?.enabled },
  )
}
